import React from "react";
import { Link } from "react-router-dom";

interface GlobalSuccessModalProps {
  id?: string;
  title?: string;
  message?: string;
  show: boolean;
  onClose: () => void;
  type?: "success" | "error"; // optional styling
}

const CustomPopup: React.FC<GlobalSuccessModalProps> = ({
  id = "globalSuccessModal",
  title = "Message",
  message = "Action completed successfully!",
  show,
  onClose,
  type = "success",
}) => {
  if (!show) return null;

  const alertClass = type === "error" ? "alert-danger" : "alert-success";

  return (
    <div
      className="modal fade show d-block"
      id={id}
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0 m-0 justify-content-end">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <div className="text-center">
              <div className={`alert ${alertClass}`} role="alert">
                <strong>{title} </strong>
                {message}
              </div>
              <div className="col-lg-12 text-center modal-btn">
                <Link to="#" className="btn btn-soft-primary" onClick={onClose}>
                  Close
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomPopup;
